import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalService } from 'src/app/services/modal.service';
import { ImportProductsModalComponent } from '../import-products-modal/import-products-modal.component';
import { RefreshProductsModalComponent } from '../refresh-products-modal/refresh-products-modal.component';

@Component({
    selector: 'app-import-modal',
    templateUrl: './import-modal.component.html',
    styleUrl: './import-modal.component.scss'
})
export class ImportModalComponent {

constructor(
    public modalService: ModalService,
    public activeModal: NgbActiveModal,
  ) { }

  importProducts() {
    this.activeModal.close();
    this.modalService.openModalWithOptions(ImportProductsModalComponent, {
      size: 'xl',
      centered: true,
      scrollable: true
    });
  }

  refreshProducts() {
    this.activeModal.close();
    this.modalService.openModalWithOptions(RefreshProductsModalComponent, {
      size: 'xl',
      centered: true
    });
  }

  cancel(): void {
    this.activeModal.close(null);
  }
}
